import React, { useEffect, useState } from "react";
import { Box, FormControl, Select, MenuItem, Grid } from "@material-ui/core";
import smartParkService from "../../axios";
import ClipLoader from "react-spinners/ClipLoader";
import HighchartsReact from "highcharts-react-official";
import HighStock from "highcharts/highstock";

const MafcEquipmentWeeklySummary = ({ options, startDate, endDate }) => {
  const [loading, setLoading] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [graphData, setGraphData] = useState([]);

  const getConfig = () => ({
    // plotOptions: {
    //   height: 100,
    // },
    title: {
      text: "",
      align: "left",
    },
    chart: {
      type: "column",
    },
    xAxis: {
      categories: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    },
    yAxis: {
      visible: false,
      min: 0,
      title: {
        text: "",
      },
    },
    tooltip: {
      split: true,
      formatter: function () {
        var crowd = this.y;
        if (crowd >= 500)
          return `Occupied <b>${crowd} minutes</b>. <br/> Usually Busy On ${this.x}`;
        else
          return `Occupied <b>${crowd} minutes</b>. <br/> Not Busy On ${this.x}`;
      },
    },
    series: [
      {
        showInLegend: false,
        data: graphData,
        color: "#0076bb",
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 600,
          },
          chartOptions: {
            xAxis: {
              labels: {
                rotation: -45,
                // align: "center",
              },
            },
          },
        },
      ],
    },
    credits: {
      enabled: false,
    },
  });

  const fetchData = () => {
    setLoading(true);
    smartParkService
      .get(
        `api/equipment/weeklysummary?startDate=${startDate}&endDate=${endDate}&facility=91474e36-76c5-4d59-a8da-2998ab14a4bf&sensor=${selectedEquipment}`
      )
      .then((res) => {
        setGraphData(res.data.resultArray);
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (options && options.length > 0) {
      setSelectedEquipment(options[0].value);
    }
  }, [options]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (selectedEquipment !== "") {
      fetchData();
    }
  }, [selectedEquipment, startDate, endDate]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        height: "100%",
        width: "100%",
        padding: "5px",
        justifyContent: "space-between",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          flex: 1,
        }}
      >
        <Box>
          {options && selectedEquipment !== "" && (
            <FormControl variant="outlined" fullWidth>
              <Select
                labelId="equipment-select-label"
                id="equipment-select"
                value={selectedEquipment}
                onChange={(e) => setSelectedEquipment(e.target.value)}
                label="Equipment"
                fullWidth
                style={{ maxWidth: "300px" }}
              >
                {options.map((option) => {
                  return (
                    <MenuItem value={option.value} key={option.value}>
                      {option.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </Box>
      </Box>
      <Box
        style={{
          flex: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ClipLoader
              loading={loading}
              size={60}
              css={{
                display: "block",
                borderColor: "#0076bb",
              }}
            />
          </Box>
        ) : (
          <Box
            style={{
              width: "100%",
              padding: "5px",
              overflow: "hidden",
            }}
          >
            <HighchartsReact
              highcharts={HighStock}
              options={getConfig(graphData)}
              containerProps={{ style: { height: "100%", width: "100%" } }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MafcEquipmentWeeklySummary;
